import OutlookCalendarIcon from './lib/icon-outlook-calendar.svg';
import OutlookMailIcon from './lib/icon-outlook-mail.svg';
import OutlookIcon from './lib/icon-outlook.svg';

export * from './lib/hosted-auth';
export * from './lib/dashboard';
export * from './lib/dashboard/oauth-scopes';

export { OutlookCalendarIcon, OutlookIcon, OutlookMailIcon };
export const outlookCalendarName = 'Outlook Calendar';
export const outlookMailName = 'Outlook Mail';
export const outlookName = 'Microsoft Outlook';

export const outlookProductIcons: Record<string, string> = {
  default: OutlookIcon,
  mail: OutlookMailIcon,
  calendar: OutlookCalendarIcon,
};

export const outlookProductLabels: Record<string, string> = {
  default: outlookName,
  mail: outlookMailName,
  calendar: outlookCalendarName,
};
